const namespace = 'Requests';

// Request datail
export const REQUEST_REQUEST_DETAIL = `${namespace}/REQUEST_REQUEST_DETAIL`;
export const RECEIVE_REQUEST_DETAIL_SUCCESS = `${namespace}/RECEIVE_REQUEST_DETAIL_SUCCESS`;
export const RECEIVE_REQUEST_DETAIL_FAILURE = `${namespace}/RECEIVE_REQUEST_DETAIL_FAILURE`;
